import { UserEvents, trackEvent } from '../usertracking/usertracking';

$(document).ready(() => {
	//	Send events for expanded rows.
	setTimeout(() => {
		$('[data-user-event="workout-week-expanded"]:not(.collapsed)').each((_index, target) => {
			const week = $(target).closest('[data-user-week]').data('user-week');

			return trackEvent(UserEvents.WorkoutWeekExpanded, {
				week,
			});
		});
		$('[data-user-event="workout-day-expanded"]:not(.collapsed)').each((_index, target) => {
			const day = $(target).closest('[data-user-day]').data('user-day');

			return trackEvent(UserEvents.WorkoutDayExpanded, {
				day,
			});
		});
		$('[data-user-event="workout-expanded"]:not(.collapsed)').each((_index, target) => {
			const workout = $(target).closest('[data-user-workout]').data('user-workout');

			return trackEvent(UserEvents.WorkoutExpanded, {
				workout,
			});
		});
		$('[data-user-event="mealplan-day-expanded"]:not(.collapsed)').each((_index, target) => {
			const day = $(target).closest('[data-user-day]').data('user-day');

			return trackEvent(UserEvents.MealPlanDayExpanded, {
				day,
			});
		});
		$('[data-user-event="mealplan-meal-expanded"]:not(.collapsed)').each((_index, target) => {
			const meal = $(target).closest('[data-user-meal]').data('user-meal');

			return trackEvent(UserEvents.MealPlanMealExpanded, {
				meal,
			});
		});
	});
	$(document).on('click', '[data-user-event]', ev => {
		const $target = $(ev.target).closest('[data-user-event]');

		switch ($target.data('user-event')) {
			case 'exercise-video-viewed': {
				const exercise = $target.closest('[data-user-exercise]').data('user-exercise');

				return trackEvent(UserEvents.ExerciseVideoViewed, {
					exercise,
				});
			}
			case 'mealplan-day-expanded': {
				if ($target.hasClass('collapsed')) {
					return;
				}

				const day = $target.closest('[data-user-day]').data('user-day');

				return trackEvent(UserEvents.MealPlanDayExpanded, {
					day,
				});
			}
			case 'mealplan-meal-expanded': {
				if ($target.hasClass('collapsed')) {
					return;
				}

				const meal = $target.closest('[data-user-meal]').data('user-meal');

				return trackEvent(UserEvents.MealPlanMealExpanded, {
					meal,
				});
			}
			case 'recipe-printed': {
				const plan = $target.closest('[data-user-plan]').data('user-plan');
				const recipe = $target.closest('[data-user-recipe]').data('user-recipe');

				return trackEvent(UserEvents.RecipePrinted, {
					plan,
					recipe,
				});
			}
			case 'shopping-list-printed': {
				const plan = $target.closest('[data-user-plan]').data('user-plan');

				return trackEvent(UserEvents.ShoppingListPrinted, {
					plan,
				});
			}
			case 'shopping-list-saved': {
				const plan = $target.closest('[data-user-plan]').data('user-plan');

				return trackEvent(UserEvents.ShoppingListSaved, {
					plan,
				});
			}
			case 'workout-day-expanded': {
				if ($target.hasClass('collapsed')) {
					return;
				}

				const day = $target.closest('[data-user-day]').data('user-day');

				return trackEvent(UserEvents.WorkoutDayExpanded, {
					day,
				});
			}
			case 'workout-printed': {
				const workout = $target.closest('[data-user-workout]').data('user-workout');

				return trackEvent(UserEvents.WorkoutPrinted, {
					workout,
				});
			}
			case 'workout-expanded': {
				if ($target.hasClass('collapsed')) {
					return;
				}

				const workout = $target.closest('[data-user-workout]').data('user-workout');

				return trackEvent(UserEvents.WorkoutExpanded, {
					workout,
				});
			}
			case 'workout-program-printed': {
				const program = $target.closest('[data-user-program]').data('user-program');

				return trackEvent(UserEvents.WorkoutProgramPrinted, {
					program,
				});
			}
			case 'workout-week-expanded': {
				if ($target.hasClass('collapsed')) {
					return;
				}

				const week = $target.closest('[data-user-week]').data('user-week');

				return trackEvent(UserEvents.WorkoutWeekExpanded, {
					week,
				});
			}
		}
	});
});
